import { Avatar, Box, Card, Skeleton, Typography } from "@mui/material";

const ProductCardSkeleton = () => {
  return (
    <Card
      style={{
        marginTop: "2rem",
        padding: "1rem",
        boxShadow: "1px 1px 9px #afafae",
        transition: "0.3s",
        borderRadius: "10px",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center" }}>
        {/* Company Icon */}
        <Skeleton variant="rectangular" height={50}>
          <Avatar style={{ width: "60px", height: "50px" }} />
        </Skeleton>
        {/* Vendor name and product name */}
        <Box sx={{ width: "100%", marginLeft: "1rem" }}>
          <Skeleton width="100%" animation="wave">
            <Typography>.</Typography>
          </Skeleton>
          <Skeleton width="100%" animation="wave">
            <Typography>.</Typography>
          </Skeleton>
        </Box>
      </Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          width: "100%",
          marginTop: "1rem",
        }}
      >
        {/* Sum Insured */}
        <Box sx={{ width: "50%", marginLeft: "11%" }}>
          <Skeleton
            animation="wave"
            height={10}
            width="70%"
            style={{ marginBottom: 6 }}
          />
          <Skeleton animation="wave" height={10} width="50%" />
        </Box>
        {/* Premium Amount */}
        <Box sx={{ width: "50%", marginLeft: "10%" }}>
          <Skeleton
            animation="wave"
            height={10}
            width="70%"
            style={{ marginBottom: 6 }}
          />
          <Skeleton animation="wave" height={10} width="50%" />
        </Box>
      </Box>
    </Card>
  );
};

export default ProductCardSkeleton;
